

















































import { computed, defineComponent } from '@vue/composition-api';
import type { PropType } from '@vue/composition-api';

import type { ID } from '@/types';

const DistrictSelector = defineComponent({
  props: {
    value: {
      default: () => ({
        district: false,
        subdistricts: [],
      }),
      type: Object as PropType<{ district: boolean; subdistricts: ID[] }>,
    },
    district: {
      default: () => ({
        id: -1,
        nameInThai: '',
        province: { id: -1, nameInThai: '' },
        subdistricts: [{
          id: -1,
          nameInThai: '',
          zipcode: '',
        }],
      }),
    },
    subdistrictLists: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
    duplicateArray: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    function updateSubdistricts(subdistrictId: string) {
      const subdistricts = [...props.value.subdistricts];
      const index = subdistricts.indexOf(subdistrictId);
      if (index > -1) {
        subdistricts.splice(index, 1);
      } else {
        subdistricts.push(subdistrictId);
      }
      const district = subdistricts.length > 0;
      emit('input', { district, subdistricts });
    }

    function clickDistrict() {
      if (props.value.district) {
        emit('input', { district: false, subdistricts: [] });
      } else {
        emit('input', {
          district: true,
          subdistricts: props.district.subdistricts.filter((sub) => !(props.subdistrictLists.includes(sub.id))).map((subdistrict) => subdistrict.id),
        });
      }
    }

    function selectAllSubdistrict() {
      const subdistricts = props.district.subdistricts.filter((sub) => !(props.subdistrictLists.includes(sub.id))).map((sub) => sub.id);
      emit('input', { district: true, subdistricts });
    }

    const zipcode = computed(() => props.district.subdistricts[0].zipcode);

    return {
      zipcode,
      clickDistrict,
      updateSubdistricts,
      selectAllSubdistrict,
    };
  },
});

export default DistrictSelector;
